import styled from '@emotion/styled';

export const ItemContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;

	body[dir='rtl'] & {
		.icon {
			transform: rotate(180deg);
		}
	}
`;

export const RecommendedContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 1rem 0;
	gap: 1.25rem;
`;

export const RecommendedItemContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	flex-wrap: wrap;

	> .tag {
		cursor: pointer;
	}
`;
